import { alertMixin } from "./alertMixin";
import axios from "@/axios.js";
export const axiosMixin = {
    mixins: [alertMixin],
    methods: {
        aronDelete(endPoint, id, msg) {
            return new Promise((resolve, reject) => {
                axios 
                    .delete( 
                        "/" + endPoint + "/" + id
                    )
                    .then(response => {
                        this.decodeSuccessFromAxios(response, msg);
                        resolve(response.data);

                    })
                    .catch(error => {
                        this.decodeErrorFromAxios(error).then((errorMsg) => {
                            reject(errorMsg);
                        });
                    });
            });
        },
        aronPostPut(endPoint, operation, payload, id) {

            var msg = operation == "add" ? "Item Added" : "Item Updated";
            return new Promise((resolve, reject) => {
                axios({
                    method: operation == "add" ? "post" : "put",
                    url:
                        operation == "add"
                            ? "/" + endPoint
                            : "/" + endPoint + "/" + id,
                    data: payload
                })
                    .then(response => {
                        this.decodeSuccessFromAxios(response, msg);
                        resolve(response.data);
                    })
                    .catch(error => {

                        this.decodeErrorFromAxios(error).then((errorMsg) => {
                            reject(errorMsg);
                        });
                    });
            });
        },
        aronGet(endPoint, params, sort) { 
            return new Promise((resolve, reject) => {
                let addParam = params !="" ? "?" .concat(params).concat(sort) : "";
                axios
                    .get(
                        "/" + endPoint + addParam,
                        { useCredentails: true }
                    )
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },
        aronPost(endPoint, payload, params, sort) {
            return new Promise((resolve, reject) => {
                axios({
                    method: "post",
                    url: "/" + endPoint + "?".concat(params).concat(sort),
                    data: payload
                })
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        }
    }
};